import { render, staticRenderFns } from "./AttributesTable.vue?vue&type=template&id=25f0f31c&"
import script from "./AttributesTable.vue?vue&type=script&lang=js&"
export * from "./AttributesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports